import React from 'react'
import { Container, Text, Button } from './styles'
import { IconComponent } from '~/assets/icons/component'

export interface TagProps {
  text: string
  color: string
  onClose?: (event) => void
}

export const Tag = ({ text, color, onClose }: TagProps): JSX.Element => {
  return (
    <Container color={color} hasCloseButton={!!onClose}>
      <Text>{text}</Text>
      {onClose ? (
        <Button aria-label={`Remover tag ${text}`} onClick={onClose}>
          <IconComponent name="close" iconsize={8} />
        </Button>
      ) : null}
    </Container>
  )
}
